import api, { getData } from '@/axiosConfig'
import { status, defaultNoTrendingImage } from '../../helpers'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'

import {
  LOAD_PRODUCTS_INVENTORY,
  SET_PRODUCTS_INVENTORY_LIST,
  LOAD_STORE_INVENTORY,
  SET_STORE_INVENTORY,
  ADD_PRODUCT_TO_REPLENISH,
  RESET_PRODUCTS_TO_REPLENISH,
  REPLENISH_PRODUCTS,
  TOGGLING_PRODUCT_VISIBILITY,
  SET_UPDATED_PRODUCT_INVENTORY,
  RESET_INVENTORY_STATE,
  INVENTORY_PAGINATION_COUNT,
  STORE_INVENTORY_PAGINATION,
  REQUEST_ESTIMATE_COUNTER,
  UPDATING_PRODUCT,
  UPDATE_PRODUCT_REPLENISH_QUANTITY
} from '@/state/mutationTypes'

export default {
  async getProductsInventory(
    { commit, dispatch },
    { sortBy, sortDirection, page = 1, perPage = 50, showLoader = true }
  ) {
    try {
      showLoader ? commit(LOAD_PRODUCTS_INVENTORY, status.LOADING) : null
      // const response = await gemnoteAPI.get(
      //   `team/product_variants?filters[${sortBy}]=${sortDirection}&page[number]=${page}&page[size]=${perPage}`
      // )
      const allInventoryResponse = await gemnoteAPI.get(
        `team/products/all_inventory?filters[${sortBy}]=${sortDirection}&page[number]=${page}&page[size]=${perPage}`
      )

      let { totalCount } = allInventoryResponse.data.meta
      let productsInventory = []
      const allInventory = getData(allInventoryResponse)
      productsInventory = allInventory.map(product => {
        const productInventoryData = allInventory.find(
          item => Number(item.id) == Number(product.attributes.productId)
        )
        let isBelowThreshold = false

        if (productInventoryData) {
          isBelowThreshold = productInventoryData.attributes.sortedProductVaraints.find(
            item => item.id == product.id
          ).belowThreshold
        }
        return {
          ...product,
          variantId: product.id,
          image:
            product.attributes.defaultProductVariantImages === null
              ? defaultNoTrendingImage
              : product.attributes.defaultProductVariantImages.length
              ? product.attributes.defaultProductVariantImages[0].url
              : defaultNoTrendingImage,
          title: product.attributes.name,
          sortedProductVaraints: product.attributes.sortedProductVaraints.map(
            item => ({
              ...item,
              variantName: item.variantName,
              replenishQuantity: 0,
              replenish: false
            })
          ),
          variantName: product.attributes.name,
          size:
            product.attributes.sortedProductVaraints.length > 1
              ? 'Multiple'
              : product.attributes.sortedProductVaraints.length > 0 &&
                product.attributes.sortedProductVaraints[0].spec.size,
          quantity: product.attributes.inventoriesCount,
          cost: product.attributes.retailPrice,
          replenish: false,
          replenishQuantity: '',
          replenishQuantityError: false,
          belowThreshold: isBelowThreshold,
          expirationDate: product.attributes.expirationDate
        }
      })
      // productsInventory = _.sortBy(productsInventory, ['id', 'title', 'size'])
      commit(INVENTORY_PAGINATION_COUNT, totalCount)
      showLoader ? commit(LOAD_PRODUCTS_INVENTORY, status.LOADED) : null
      commit(SET_PRODUCTS_INVENTORY_LIST, productsInventory)
    } catch (error) {
      commit(LOAD_PRODUCTS_INVENTORY, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.product-inventory-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getStoreInventory({ commit, dispatch }, { page = 1, perPage = 50 }) {
    try {
      commit(LOAD_STORE_INVENTORY, status.LOADING)
      let response = await gemnoteAPI.get(
        `team/products?page[number]=${page}&page[size]=${perPage}`
      )
      const { totalCount } = response.data.meta
      let products = getData(response)
      products = products.map(product => {
        return {
          id: product.id,
          image: product.attributes.defaultProductVariantImages.length
            ? product.attributes.defaultProductVariantImages[0].url
            : defaultNoTrendingImage,
          title: product.attributes.name,
          cost: product.attributes.retailPrice,
          category: 'Gift',
          adminOnly: product.attributes.adminOnly,
          description: product.attributes.description,
          expirationDate: product.attributes.expirationDate
        }
      })

      response = await gemnoteAPI.get(`team/bundles`)
      let bundles = getData(response)
      bundles = bundles.map(bundle => {
        return {
          id: bundle.id,
          image: bundle.attributes.images.length
            ? bundle.attributes.images[0].url
            : 'https://s3-us-west-1.amazonaws.com/gemnote.com/gemnote-no-image.png',
          title: bundle.attributes.name,
          cost: bundle.attributes.lowestPrice,
          category: 'Bundle',
          adminOnly: bundle.attributes.adminOnly
        }
      })

      let storeProducts = [...products, ...bundles]
      commit(STORE_INVENTORY_PAGINATION, totalCount)
      commit(LOAD_STORE_INVENTORY, status.LOADED)
      commit(SET_STORE_INVENTORY, storeProducts)
    } catch (error) {
      console.log(error)
      commit(LOAD_STORE_INVENTORY, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.store-inventory-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async addProductToReplenish({ commit }, { originalIndex, id }) {
    let productToReplenish = {
      originalIndex,
      id
    }
    commit(ADD_PRODUCT_TO_REPLENISH, productToReplenish)
  },
  async updateProductReplenishQuantity(
    { commit },
    {
      originalIndex,
      id,
      quantity,
      variantId,
      variantIndex,
      isVariant,
      needsReplenish,
      replenishQuantityError,
      cost,
      replenish
    }
  ) {
    let productToReplenish = {
      originalIndex,
      id,
      quantity,
      variantId,
      variantIndex,
      isVariant,
      needsReplenish,
      replenishQuantityError,
      cost,
      replenish
    }
    commit(UPDATE_PRODUCT_REPLENISH_QUANTITY, productToReplenish)
  },
  async replenishProducts({ commit, dispatch, rootGetters }, items) {
    try {
      let productsToReplenish =
        items && items.length
          ? items
          : rootGetters['inventory/productsToReplenish']

      if (productsToReplenish.length) {
        commit(REPLENISH_PRODUCTS, true)
        const variantsToReplenish = []
        productsToReplenish.forEach(product => {
          if (product.sortedProductVaraints.length > 1) {
            product.sortedProductVaraints.forEach(variant => {
              if (variant.replenish) {
                variantsToReplenish.push({
                  id: parseInt(variant.id),
                  quantity: parseInt(variant.replenishQuantity)
                })
              }
            })
          } else {
            if (product.replenish) {
              variantsToReplenish.push({
                id: parseInt(product.variantId),
                quantity: parseInt(product.replenishQuantity)
              })
            }
          }
        })
        let body = {
          product_variants: variantsToReplenish
        }
        await gemnoteAPI.post(`team/inventories/replenish_inventories`, body)
        commit(RESET_PRODUCTS_TO_REPLENISH)
        commit(REQUEST_ESTIMATE_COUNTER, 1)
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            title: 'Restock request submitted',
            messages: ['You will receive an email confirmation soon. ']
          },
          { root: true }
        )
        commit(REPLENISH_PRODUCTS, false)
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('validations.empty-products-restock')]
          },
          { root: true }
        )
      }
    } catch (error) {
      console.log(error)
      commit(REPLENISH_PRODUCTS, false)
      commit(REQUEST_ESTIMATE_COUNTER, 0)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.replenish-products-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async setStockThresholdLimit({ dispatch }, stockThresholdLimit) {
    try {
      const requestData = {
        team: { stock_threshold_limit: stockThresholdLimit }
      }

      await gemnoteAPI.post(`/team/set_stock_threshold_limit`, requestData)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [
            i18n.t('inventory.action.product-update-threshold-success')
          ]
        },
        { root: true }
      )
      await dispatch('team/getTeam', {}, { root: true })
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.toggle-product-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async toggleInventoryNotification({ dispatch }, notifications_enabled) {
    try {
      const requestData = {
        team: { stock_threshold_notifications_enabled: notifications_enabled }
      }

      await gemnoteAPI.patch(`/team`, requestData)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [
            i18n.t('inventory.action.toggle-inventory-notification-success')
          ]
        },
        { root: true }
      )
      await dispatch('team/getTeam', {}, { root: true })
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.toggle-product-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async toggleAdminOnlyProduct(
    { commit, dispatch },
    { originalIndex, id, category, adminOnly }
  ) {
    try {
      let body = {
        type: category
      }
      commit(TOGGLING_PRODUCT_VISIBILITY, status.LOADING)
      const response = await gemnoteAPI.put(`team/menu_items/${id}`, body)
      if (response.data.errors) {
        let toggledProduct = {
          originalIndex,
          id,
          adminOnly
        }
        commit(SET_UPDATED_PRODUCT_INVENTORY, toggledProduct)
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [response.data.errors]
          },
          { root: true }
        )

        commit(TOGGLING_PRODUCT_VISIBILITY, status.ERROR)
      } else {
        let toggledProduct = {
          originalIndex,
          id,
          adminOnly: !adminOnly
        }
        commit(SET_UPDATED_PRODUCT_INVENTORY, toggledProduct)
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: [i18n.t('inventory.action.toggle-product-success')]
          },
          { root: true }
        )

        commit(TOGGLING_PRODUCT_VISIBILITY, status.LOADED)
      }
    } catch (error) {
      console.log(error)
      commit(TOGGLING_PRODUCT_VISIBILITY, status.ERROR)
      let toggledProduct = {
        originalIndex,
        id,
        adminOnly
      }
      commit(SET_UPDATED_PRODUCT_INVENTORY, toggledProduct)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.toggle-product-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async updateProduct({ commit, dispatch, rootState }, product) {
    try {
      const requestData = {
        product: {
          description: product.description,
          e_commerce_price: product.cost,
          name: product.title
        }
      }
      const storeSlug = rootState.ecommerce.shopDetails.slug
      const productId = product.id
      commit(UPDATING_PRODUCT, status.LOADING)
      await gemnoteAPI.patch(
        `/store_front/${storeSlug}/products/${productId}`,
        requestData
      )
      commit(UPDATING_PRODUCT, status.LOADED)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('inventory.action.product-update-success')]
        },
        { root: true }
      )
      dispatch(
        'ecommerce/getStoreProducts',
        rootState.ecommerce.shopDetails.slug,
        { root: true }
      )
      commit(UPDATING_PRODUCT, status.LOADED)
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('inventory.action.toggle-product-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  resetProductState({ commit }) {
    commit(RESET_INVENTORY_STATE)
  },
  resetRequestEstimateCount({ commit }) {
    commit(REQUEST_ESTIMATE_COUNTER, 0)
  }
}
